export const AI_TEXT_PRICING_PER_MILLION = Object.freeze({
  'gpt-5': { input: 1.25, cachedInput: 0.125, output: 10.0 },
  'gpt-5-mini': { input: 0.25, cachedInput: 0.025, output: 2.0 },
  'gpt-5-nano': { input: 0.05, cachedInput: 0.005, output: 0.4 },
})

export const FREE_OPERATION_AI_CONFIG = Object.freeze([
  { key: 'QUOTE_STRUCTURE', feature: '견적 요청 구조화', model: 'gpt-5-nano', fallbackModel: null, prompt: 'quote-structure-v0.5', enabled: true, fallback: 'JSON schema 검증 실패 시 규칙 기반 재처리', budgetUsdPerDay: 2, note: '분류·필드 추출 중심이라 nano 우선' },
  { key: 'DIRECTOR_PROFILE', feature: '디렉터/포트폴리오 분석', model: 'gpt-5-nano', fallbackModel: 'gpt-5-mini', prompt: 'portfolio-analysis-v0.5', enabled: true, fallback: 'confidence 낮음/스키마 검증 실패 시 mini 1회', budgetUsdPerDay: 3, note: '변경 저장마다 호출하지 않고 변경 건을 모아 3시간마다 최신 상태 1회 분석' },
  { key: 'CURATION_RERANK', feature: '큐레이션 GPT 재정렬', model: 'gpt-5-nano', fallbackModel: null, prompt: 'curation-rerank-v0.3', enabled: false, fallback: 'DB 필터 + pgvector + Hybrid score', budgetUsdPerDay: 1, note: '무료 운영기간 기본 OFF. 동점·저신뢰 후보에만 선택 호출' },
  { key: 'MOCKUP_PROMPT', feature: 'AI 시안 프롬프트 정리', model: 'gpt-5-nano', fallbackModel: null, prompt: 'mockup-prompt-v0.3', enabled: true, fallback: '입력 원문을 템플릿에 직접 삽입', budgetUsdPerDay: 1, note: '짧은 구조화 프롬프트만 생성' },
  { key: 'MOCKUP_IMAGE', feature: 'AI 시안 이미지', model: 'gpt-image-2', fallbackModel: null, prompt: 'mockup-image-v0.3', enabled: true, fallback: '생성 없이 디렉터 직접 이미지 첨부', budgetUsdPerDay: 8, note: '사용자 자동 생성 금지. 디렉터가 명시적으로 요청할 때 low quality 1장부터' },
])

export const FREE_OPERATION_AI_POLICY = Object.freeze({
  mode: 'FREE_OPERATION',
  textModelDefault: 'gpt-5-nano',
  textModelEscalation: 'gpt-5-mini',
  fullModelAllowed: false,
  rerankDefaultEnabled: false,
  maxImageDraftsPerAction: 1,
  cacheEnabled: true,
  batchForOfflineAnalysis: true,
  directorAnalysisIntervalMinutes: 180,
  directorAnalysisCoalesceChanges: true,
  directorAnalysisOnRead: false,
})
